import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Modal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import { StatusAlertService } from 'react-status-alert'
import MessageUtils from '../../util/MessageUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import TaskListPageUI from './TaskListPageUI.js'
import {insertTask, removeTask, replaceTask}
        from '../../components/projectapp/taskList/helper/taskListCRUDHelper'
import {findPreviousVisibleTask, findNextVisibleTask}
        from '../../components/projectapp/taskList/helper/visibleTaskListHelper'
import {findTask, findSiblingTasks, findPreviousSiblingTask,
        findParentTasks, printTaskTree}
        from '../../components/projectapp/taskList/helper/taskListHelper'

class TaskListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      project: null,
      taskList: null,
      currentTask: null,
      pageRendered: false,
      projectUserList: null,
      projectUserMap: null,
      moveMode: false,
      // filters
      statusFilter: '-1',
      priorityFilter: '-1',
      searchFilter: '',
      assigneeFilter: '-1',
      dueDateDaysFilter: '',
      unfoldedTaskIdSet: new Set(),
      // list of values
      statusList: null,
      priorityList: null,
      // delete modal
      deleteModal: false,
      deleteSubmitted: false,
      deleteErrorList: null,
      deleteSuccessMsg: null,
    }

    this.class = 'TaskListPageSF'
  }

  render() {
    return (
      <TaskListPageUI
        context={this.props.context}
        project={this.state.project}
        taskList={this.state.taskList}
        currentTask={this.state.currentTask}
        messageList={this.state.messageList}
        pageRendered={this.state.pageRendered}
        projectUserList={this.state.projectUserList}
        projectUserMap={this.state.projectUserMap}
        moveMode={this.state.moveMode}
        // top action clicks
        onRefreshClick={this.onRefreshClick}
        onUnfoldAllClick={this.onUnfoldAllClick}
        onFoldAllClick={this.onFoldAllClick}
        onCreateClick={this.onCreateClick}
        onDeleteClick={this.onDeleteClick}
        onIndentClick={this.onIndentClick}
        onOutdentClick={this.onOutdentClick}
        onMoveClick={this.onMoveClick}
        // filters
        statusFilter={this.state.statusFilter}
        searchFilter={this.state.searchFilter}
        priorityFilter={this.state.priorityFilter}
        assigneeFilter={this.state.assigneeFilter}
        dueDateDaysFilter={this.state.dueDateDaysFilter}
        onStatusFilterChange={this.onStatusFilterChange}
        onSearchFilterChange={this.onSearchFilterChange}
        onAssigneeFilterClick={this.onAssigneeFilterClick}
        onPriorityFilterChange={this.onPriorityFilterChange}
        onDueDateDaysFilterChange={this.onDueDateDaysFilterChange}
        unfoldedTaskIdSet={this.state.unfoldedTaskIdSet}
        // row level clicks
        onTaskClick={this.onTaskClick}
        onUnfoldClick={this.onUnfoldClick}
        onFoldClick={this.onFoldClick}
        onSetEditMode={this.onSetEditMode}
        onTaskNameCreateOrUpdate={this.onTaskNameCreateOrUpdate}
        // delete modal
        deleteErrorList={this.state.deleteErrorList}
        deleteSuccessMsg={this.state.deleteSuccessMsg}
        setDeleteErrorList={(errorList) => this.setState({deleteErrorList: errorList})}
        onCancelDelete={(event) => {this.setState({deleteModal: false})}}
        onDeleteSubmit={this.onDeleteSubmit}
        deleteSubmitted={this.state.deleteSubmitted}
        deleteModal={this.state.deleteModal}
        // dnd
        onBeforeCapture={this.onBeforeCapture}
        onDragEnd={this.onDragEnd}
        // list of values
        statusList={this.state.statusList}
        priorityList={this.state.priorityList}
        // task detail event handler
        onTaskListUpdated={this.onTaskListUpdated}
        onForceTaskListRefresh={this.onForceTaskListRefresh}
        onForceProjectUserListRefresh={this.onForceProjectUserListRefresh}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAndSetUnfoldedTaskIdSet()
    this.getTaskTree(context)

    this.getProjectUsers(context)
    this.getProjects(context)
    this.getMessages(context)
    this.getTaskStatuses(context)
    this.getTaskPriorities(context)
    Modal.setAppElement('body')
    /* need to add these if task list is not empty */
    if (this.state.taskList && this.state.taskList.length > 0) {
      document.body.classList.add('g_h_100')
      document.getElementById('root').classList.add('g_h_100')
      document.getElementsByTagName('main')[0].classList.add('g_h_100')
    }
    document.addEventListener("keydown", this.onKeyDown, false)
  }

  componentWillUnmount() {
    document.body.classList.remove('g_h_100')
    document.getElementById('root').classList.remove('g_h_100')
    document.getElementsByTagName('main')[0].classList.remove('g_h_100')
    document.removeEventListener("keydown", this.onKeyDown, false)
  }

  componentDidUpdate() {
    ReactTooltip.rebuild()
  }

  getAndSetUnfoldedTaskIdSet() {
    let unfoldedTaskIdStr = sessionStorage.getItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId))
    let unfoldedTaskIdList = unfoldedTaskIdStr ? JSON.parse(unfoldedTaskIdStr) : []
    this.setState({unfoldedTaskIdSet: new Set(unfoldedTaskIdList)})
  }

  getAndSetCurrentTask(taskList) {
    let currentTaskId = sessionStorage.getItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
    let currentTask = findTask(taskList, currentTaskId)
    this.setState({currentTask: currentTask})
  }

  getTaskTree(context) {
    console.log(this.class, '------------------------ getTaskTree');
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.props.match.params.projectId}/tasks`,
      cacheKey: CacheKeys.TaskTree(this.props.match.params.projectId),
      callback: this.getTaskTreeCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskTreeCallback = (response) => {
    console.log(this.class, '------------------------ getTaskTreeCallback')

    // currentTask is set whether task is filtered/folded or not
    // if currentTask is not to be set, then set currentTask in applyFilters
    this.getAndSetCurrentTask(response.taskList)

    let filtersStr = sessionStorage.getItem(CacheKeys.TasksFilter(this.props.match.params.projectId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(
      response.taskList,
      filters.statusFilter ? filters.statusFilter : '-1',
      filters.priorityFilter ? filters.priorityFilter : '-1',
      filters.dueDateDaysFilter ? filters.dueDateDaysFilter : '',
      filters.searchFilter ? filters.searchFilter : '',
      filters.assigneeFilter ? filters.assigneeFilter : '-1'
    )
  }

  onRefreshClick = (event) => {
    let currentTask = this.state.currentTask
    if (currentTask && currentTask.editMode) {
      console.log('onRefreshClick', 'editMode');
      return
    }

    CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
    this.setState({taskList: null}, this.getTaskTree(this.props.context))
  }

  onForceTaskListRefresh = (projectId) => {
    CacheManager.removeObject(CacheKeys.TaskTree(projectId))
    this.setState({taskList: null}, this.getTaskTree(this.props.context))
  }

  onForceProjectUserListRefresh = (projectId) => {
    CacheManager.removeObject(CacheKeys.ProjectUsers(projectId))
    this.setState({projectUserList: null}, this.getProjectUsers(this.props.context))
  }

  onUnfoldClick = (event) => {
    event.stopPropagation()
    let taskId = event.target.getAttribute('data-task-id')
    this.state.unfoldedTaskIdSet.add(taskId)
    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet})
    sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId),
      JSON.stringify([...this.state.unfoldedTaskIdSet]))
  }

  onFoldClick = (event) => {
    event.stopPropagation()
    let taskId = event.target.getAttribute('data-task-id')
    this.state.unfoldedTaskIdSet.delete(taskId)
    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet})
    sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId),
      JSON.stringify([...this.state.unfoldedTaskIdSet]))

    // if current task is getting hidden, not removing it for now
    // earlier we were setting foldingTask as currentTask
    /*
    if (this.state.currentTask) {
      let foldingTask = findTask(this.state.taskList, taskId)
      let currentTask = findTask(foldingTask.taskList, this.state.currentTask.taskId)
      if (currentTask) {
        this.setState({currentTask: foldingTask})
        sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), foldingTask.taskId)
      }
    }
    */
  }

  onUnfoldAllClick = (event) => {
    let parentTaskList = findParentTasks(this.state.taskList)
    console.log(parentTaskList);
    parentTaskList.forEach(task => this.state.unfoldedTaskIdSet.add(task.taskId))
    console.log(this.state.unfoldedTaskIdSet);
    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet})
    sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId),
      JSON.stringify([...this.state.unfoldedTaskIdSet]))
    // task list already filtered, no need to filter again
  }

  onFoldAllClick = (event) => {
    this.state.unfoldedTaskIdSet.clear()
    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet})
    sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId), JSON.stringify([]))
  }

  onTaskClick = (event) => {
    let taskId = event.currentTarget.getAttribute('data-row-id')
    console.log('onTaskClick', taskId);
    let currentTask = this.state.currentTask
    if (currentTask && currentTask.editMode) {
      return
    }
    if (currentTask && currentTask.taskId === taskId) {
      this.setState({currentTask: null})
      sessionStorage.removeItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
      return
    }
    if (!currentTask || currentTask.taskId !== taskId) {
      let task = findTask(this.state.taskList, taskId)
      this.setState({currentTask: task})
      sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), task.taskId)
    }
  }

  applyFilters(taskList, statusFilter, priorityFilter, dueDateDaysFilter, searchFilter, assigneeFilter) {
    this.markFiltered(taskList, statusFilter, priorityFilter, dueDateDaysFilter, searchFilter, assigneeFilter)

    let parentTaskMap = {}
    this.createParentSet(taskList, parentTaskMap)
    this.markParentsFiltered(taskList, parentTaskMap)

    this.setState({
      taskList: taskList,
      pageRendered: true,
      searchFilter: searchFilter,
      statusFilter: statusFilter,
      priorityFilter: priorityFilter,
      assigneeFilter: assigneeFilter,
      dueDateDaysFilter: dueDateDaysFilter,
    })

    // save filters
    let filters = {
      statusFilter: statusFilter,
      searchFilter: searchFilter,
      priorityFilter: priorityFilter,
      assigneeFilter: assigneeFilter,
      dueDateDaysFilter: dueDateDaysFilter
    }
    sessionStorage.setItem(CacheKeys.TasksFilter(this.props.match.params.projectId), JSON.stringify(filters))
  }

  markFiltered(taskList, statusFilter, priorityFilter, dueDateDaysFilter, searchFilter, assigneeFilter) {
    let dueDateDays = Number(dueDateDaysFilter)

    taskList.forEach(task => {
      if (
        (statusFilter === '-1' || task.status === statusFilter) &&
        (priorityFilter === '-1' || task.priority === priorityFilter) &&
        (!dueDateDaysFilter ||
          (dueDateDays >= 0 && task.dueDateDays && task.dueDateDays >= 0 && task.dueDateDays <= dueDateDays) ||
          (dueDateDays < 0 && task.dueDateDays && task.dueDateDays <= 0 && task.dueDateDays >= dueDateDays)
        ) &&
        (!searchFilter || task.taskName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())) &&
        (assigneeFilter === '-1' || task.userId === assigneeFilter)
      ) {
        task.filtered = false
      }
      else {
        task.filtered = true
      }
      if (task.taskList.length > 0)
        this.markFiltered(task.taskList, statusFilter, priorityFilter, dueDateDaysFilter, searchFilter, assigneeFilter)
    })
  }

  createParentSet(taskList, parentTaskMap) {
    taskList.filter(task => task.taskList.length > 0).forEach(task => {
      parentTaskMap[task.taskId] = task
      this.createParentSet(task.taskList, parentTaskMap)
    })
  }

  markParentsFiltered(taskList, parentTaskMap) {
    taskList.forEach(task => {
      let current = task
      let parentWasFiltered = true
      while (!current.filtered && current.parentTaskId && parentWasFiltered) {
        let parentTask = parentTaskMap[current.parentTaskId]
        if (parentTask.filtered)
          parentTask.filtered = false
        else
          parentWasFiltered = false
        current = parentTask
      }
      if (task.taskList.length > 0)
        this.markParentsFiltered(task.taskList, parentTaskMap)
    })
  }

  onCreateClick = (event) => {
    // skip if already creating another task
    /*
    let task = findTask(this.state.taskList, 'create')
    if (task !== null) {
      console.log('onCreateClick', 'creating another');
      return
    }
    */
    let currentTask = this.state.currentTask
    if (currentTask && currentTask.editMode) {
      console.log('onCreateClick', 'editMode');
      return
    }

    let newTask = {
      taskId: 'create',
      editMode: true,
      taskName: MessageUtils.getMessageValue(this.state.messageList, 'c_new_task'),
      taskList: []
    }
    let taskList = this.state.taskList
    if (!currentTask) { // create at the top
      taskList.unshift(newTask)
      newTask.parentTaskId = null
      newTask.precedingTaskId = null
      console.log('onCreateClick', taskList)
    }
    else {
      // if current task has subtasks and unfolded, create as first child
      if (currentTask.taskList.length > 0 && this.state.unfoldedTaskIdSet.has(currentTask.taskId)) {
          newTask.parentTaskId = currentTask.taskId
          newTask.precedingTaskId = null
          currentTask.taskList.unshift(newTask)
      }
      // create as next sibling
      else {
        let siblingTasks = findSiblingTasks(this.state.taskList, currentTask)
        let index = siblingTasks.findIndex((task) => task.taskId === currentTask.taskId)
        newTask.parentTaskId = siblingTasks[index].parentTaskId
        newTask.precedingTaskId = siblingTasks[index].taskId
        siblingTasks.splice(index + 1, 0, newTask)
        console.log('onCreateClick', siblingTasks)
      }
    }
    this.setState({taskList: taskList, currentTask: newTask})
    console.log(taskList);
    sessionStorage.removeItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
  }

  onSetEditMode = (taskId, editMode) => {
    console.log('onSetEditMode', taskId, editMode, '-----')
    let currentTask = this.state.currentTask
    let task = findTask(this.state.taskList, taskId)

    if (editMode) {
      // if another task is in edit mode, cancel it first
      if (currentTask && currentTask.taskId !== taskId && currentTask.editMode) {
        console.log('onSetEditMode, cancel edit mode', currentTask.taskName)
        currentTask.editMode = false
      }
      task.editMode = true
      this.setState({taskList: this.state.taskList, currentTask: task})
      sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), task.taskId)
    }
    else {
      // if creating, remove task
      if (taskId === 'create') {
        let previousTask = findPreviousVisibleTask(this.state.taskList, task, this.state.unfoldedTaskIdSet)
        removeTask(this.props.match.params.projectId, this.state.taskList, task)
        this.setState({taskList: this.state.taskList, currentTask: previousTask})
        if (previousTask)
          sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), previousTask.taskId)
      }
      else {
        task.editMode = false
        this.setState({taskList: this.state.taskList})
      }
    }

    this.setState({taskList: this.state.taskList})
    console.log('onSetEditMode', task.taskName, task.editMode)
  }

  onTaskNameCreateOrUpdate = (taskId, taskName) => {
    if (taskId === 'create') {
      this.createTask(taskName)
    }
    else {
      this.updateTaskName(taskId, taskName)
    }
  }

  createTask(taskName) {
    let task = findTask(this.state.taskList, 'create')
    RestApiUtils.post(this.props.context,
      `/api/projects/${this.props.match.params.projectId}/tasks/${task.parentTaskId ? task.parentTaskId : 'root'}/tasks`,
      this.createTaskCallback, {
        precedingTaskId: task.precedingTaskId,
        taskName: taskName,
      }
    )
  }

  createTaskCallback = (response) => {
    if (response.errorList.length > 0) {
      StatusAlertService.showError(response.errorList[0].message, {withCloseIcon: false})
      CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
      this.setState({taskList: null, currentTask: null}, this.getTaskTree(this.props.context))
      return
    }
    // multiple tasks could be returned as precedingTaskId changed for any following task
    let currentTask
    response.updatedTaskList.forEach(updatedTask => {
      console.log('createTaskCallback', updatedTask);
      updatedTask.editMode = false
      if (updatedTask.created) { // newly created task
        replaceTask(this.state.taskList, 'create', updatedTask)
        currentTask = updatedTask
      }
      else {
        let replaced = replaceTask(this.state.taskList, updatedTask.taskId, updatedTask)
        if (!replaced) {
          CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
          this.setState({taskList: null, currentTask: null}, this.getTaskTree(this.props.context))
        }
      }
    })
    this.setState({taskList: this.state.taskList, currentTask: currentTask})
    sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), currentTask.taskId)
    StatusAlertService.showSuccess(response.success, {withCloseIcon: false})
    // after create task, applyFilter is not run because not desired to hide created task immediately
  }

  updateTaskName(taskId, taskName) {
    RestApiUtils.put(this.props.context,
      `/api/tasks/${taskId}/task-name`,
      this.updateTaskNameCallback, {
        taskName: taskName,
      }
    )
  }

  updateTaskNameCallback = (response) => {
    if (response.errorList.length > 0) {
      StatusAlertService.showError(response.errorList[0].message, {withCloseIcon: false})
      CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
      this.setState({taskList: null, currentTask: null}, this.getTaskTree(this.props.context))
      return
    }
    replaceTask(this.state.taskList, response.task.taskId, response.task)

    /*
    if (this.state.currentTask && this.state.currentTask.editMode) {
      // another task being edited because task name was clicked
      this.setState({taskList: this.state.taskList})
    }
    else {
    */
      this.setState({taskList: this.state.taskList, currentTask: response.task})
    // }

    StatusAlertService.showSuccess(response.success, {withCloseIcon: false})

    if (response.task.taskLog) {
      var event = new CustomEvent('taskLogList', { detail: [response.task.taskLog] })
      document.body.dispatchEvent(event)
    }
  }

  onDeleteClick = (event) => {
    let currentTask = this.state.currentTask
    if (!currentTask)
      return
    if (currentTask.editMode) {
      console.log('onDeleteClick', 'editMode');
      return
    }

    if (currentTask.taskList.length > 0) {
      this.setState({deleteModal: true})
    }
    else {
      RestApiUtils.delete(this.props.context,
        `/api/tasks/${currentTask.taskId}`,
        this.deleteTaskCallback, {}
      )
    }
  }

  onDeleteSubmit = (event) => {
    this.setState({deleteSubmitted: true})
    RestApiUtils.delete(this.props.context,
      `/api/tasks/${this.state.currentTask.taskId}`,
      this.deleteTaskCallback, {}
    )
  }

  deleteTaskCallback = (response) => {
    if (response.errorList.length > 0) {
      StatusAlertService.showError(response.errorList[0].message, {withCloseIcon: false})
      CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
      this.setState({taskList: null, currentTask: null, deleteSubmitted: false, deleteModal: false},
        this.getTaskTree(this.props.context)
      )
      return
    }

    let nextTask = findNextVisibleTask(this.state.taskList, this.state.currentTask, this.state.unfoldedTaskIdSet)

    // multiple tasks could be returned: 1. subtree deleted, 2. younger sibling updated
    // first remove deleted tasks from tree
    response.updatedTaskList.filter(updatedTask => updatedTask.deleted)
      .forEach(updatedTask => {
        removeTask(this.props.match.params.projectId, this.state.taskList, updatedTask)
      })
    // second, replace non-deleted tasks
    response.updatedTaskList.filter(updatedTask => !updatedTask.deleted)
      .forEach(updatedTask => {
        replaceTask(this.state.taskList, updatedTask.taskId, updatedTask)
      })

    // get this again because attributes have changed
    nextTask = findTask(this.state.taskList, nextTask && nextTask.taskId)

    this.setState({taskList: this.state.taskList, currentTask: nextTask, deleteSubmitted: false, deleteModal: false})
    if (nextTask) {
      sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), nextTask.taskId)
    }
    else {
      sessionStorage.removeItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
    }
    StatusAlertService.showSuccess(response.success, {withCloseIcon: false})
  }

  // if preceding task is folded, need to unfold first and then call indent
  // so that indented task is added as the last child of predecessor
  onIndentClick = (event) => {
    let currentTask = this.state.currentTask
    if (!currentTask || !currentTask.precedingTaskId)
      return
    if (currentTask.editMode) {
      console.log('onIndentClick', 'editMode');
      return
    }

    // if previous sibling is folded, then unfold sibling first; non-parent previous sibling will be new parent
    let previousSiblingTask = findPreviousSiblingTask(this.state.taskList, currentTask)
    if (!this.state.unfoldedTaskIdSet.has(previousSiblingTask.taskId)) {
      this.state.unfoldedTaskIdSet.add(previousSiblingTask.taskId)
      sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId),
        JSON.stringify([...this.state.unfoldedTaskIdSet]))
    }

    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet},
      RestApiUtils.put(this.props.context,
        `/api/tasks/${currentTask.taskId}/indent`,
        this.moveTaskCallback, {}
      )
    )
  }

  onOutdentClick = (event) => {
    let currentTask = this.state.currentTask
    if (!currentTask || !currentTask.parentTaskId)
      return
    if (currentTask.editMode) {
      console.log('onOutdentClick', 'editMode');
      return
    }

    RestApiUtils.put(this.props.context,
      `/api/tasks/${currentTask.taskId}/outdent`,
      this.moveTaskCallback, {}
    )
  }

  // https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/responders.md
  onBeforeCapture = (start, provided) => {
    console.log(start, provided)
    // check if dragging task is unfolded; if unfolded then fold the task
    // unfolded task drag does not work on the UI
    const taskId = start.draggableId
    if (!this.state.unfoldedTaskIdSet.has(taskId)) {
      return
    }
    this.state.unfoldedTaskIdSet.delete(taskId)
    this.setState({unfoldedTaskIdSet: this.state.unfoldedTaskIdSet})
    sessionStorage.setItem(CacheKeys.TasksUnfolded(this.props.match.params.projectId),
      JSON.stringify([...this.state.unfoldedTaskIdSet]))
  }

  onDragEnd = ({draggableId, destination}) => {
    console.log(draggableId, destination)
    if (!destination)
      return

    let task = findTask(this.state.taskList, draggableId)
    let newParentTaskId = destination.droppableId
    let newParentTask = newParentTaskId === 'root' ? null : findTask(this.state.taskList, newParentTaskId)
    let newIndex = destination.index

    // if original parent and new parent are same, and task is dragged downwards,
    // then actual index needs to be index+1 (because index is calculated after task is dragged out)
    if (newParentTask === null && task.parentTaskId === null) {
      let oldIndex = this.state.taskList.map(task => task.taskId).indexOf(task.taskId)
      console.log(oldIndex, newIndex)
      if (oldIndex === newIndex) // no move
        return
      if (oldIndex < newIndex)
        newIndex++
    }
    if (newParentTask !== null && task.parentTaskId === newParentTaskId) {
      let oldIndex = newParentTask.taskList.map(task => task.taskId).indexOf(task.taskId)
      console.log(oldIndex, newIndex)
      if (oldIndex === newIndex) // no move
        return
      if (oldIndex < newIndex)
        newIndex++
    }

    let newPrecedingTask = newIndex === 0 ? null : newParentTask ? newParentTask.taskList[newIndex-1] : this.state.taskList[newIndex-1]
    console.log('Parent: ', newParentTask && newParentTask.taskName, ', preceding: ', newPrecedingTask && newPrecedingTask.taskName)

    // update tree before calling api
    removeTask(this.props.match.params.projectId, this.state.taskList, task)
    task.parentTaskId = newParentTask && newParentTask.taskId
    task.precedingTaskId = newPrecedingTask && newPrecedingTask.taskId
    insertTask(this.props.match.params.projectId, this.state.taskList, task)

    RestApiUtils.put(this.props.context,
      `/api/tasks/${task.taskId}/move`,
      this.moveTaskCallback, {
        taskName: task.taskName,
        newParentTaskId: newParentTask && newParentTask.taskId,
        newParentTaskName: newParentTask && newParentTask.taskName,
        newPrecedingTaskId: newPrecedingTask && newPrecedingTask.taskId,
        newPrecedingTaskName: newPrecedingTask && newPrecedingTask.taskName,
      }
    )
  }

  moveTaskCallback = (response) => {
    if (response.errorList.length > 0) {
      StatusAlertService.showError(response.errorList[0].message, {withCloseIcon: false})
      CacheManager.removeObject(CacheKeys.TaskTree(this.props.match.params.projectId))
      this.setState({taskList: null, currentTask: null}, this.getTaskTree(this.props.context))
      return
    }

    let currentTask
    // first remove and insert moved task
    response.updatedTaskList.filter(updatedTask => updatedTask.moved)
      .forEach(updatedTask => {
        let oldTask = findTask(this.state.taskList, updatedTask.taskId)
        updatedTask.taskList = oldTask.taskList
        removeTask(this.props.match.params.projectId, this.state.taskList, oldTask)
        insertTask(this.props.match.params.projectId, this.state.taskList, updatedTask)
        currentTask = updatedTask
      })
    // second, replace non-moved tasks
    response.updatedTaskList.filter(updatedTask => !updatedTask.moved)
      .forEach(updatedTask => {
        replaceTask(this.state.taskList, updatedTask.taskId, updatedTask)
      })

    this.applyFilters(this.state.taskList,
      this.state.statusFilter, this.state.priorityFilter, this.state.dueDateDaysFilter,
      this.state.searchFilter, this.state.assigneeFilter)

    this.setState({currentTask: currentTask})
  }

  onMoveClick = (event) => {
    this.setState({moveMode: !this.state.moveMode})
  }

  onTaskListUpdated = updatedTaskList => {
    let currentTask
    updatedTaskList.forEach(updatedTask => {
        if (updatedTask.taskId === this.state.currentTask.taskId)
          currentTask = updatedTask
        replaceTask(this.state.taskList, updatedTask.taskId, updatedTask)
      }
    )
    this.setState({taskList: this.state.taskList, currentTask: currentTask})
  }

  onKeyDown = (event) => {
    let participant = this.state.project && this.state.project.permissionList.includes('prj_participate')
    switch (event.keyCode) {
      case 13: // enter
        if (event.shiftKey && participant) {
          event.preventDefault()
          this.onCreateClick(event)
        }
        break;
      case 8: // backspace
      case 46: // del
        if (event.shiftKey && participant) {
          this.onDeleteClick(event)
        }
        break;
      case 9: // tab
        if (participant) {
          event.preventDefault();
          event.shiftKey && this.onOutdentClick(event)
          ! event.shiftKey && this.onIndentClick(event)
        }
        break;
      case 38: // up
        event.preventDefault()
        let previousTask = findPreviousVisibleTask(this.state.taskList, this.state.currentTask, this.state.unfoldedTaskIdSet)
        this.setState({currentTask: previousTask})
        if (previousTask) {
          sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), previousTask.taskId)
          previousTask._element.scrollIntoView({block: 'nearest', behavior: 'smooth'})
        }
        else {
          sessionStorage.removeItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
        }
        break
      case 40: // down
        event.preventDefault()
        let nextTask = findNextVisibleTask(this.state.taskList, this.state.currentTask, this.state.unfoldedTaskIdSet)
        this.setState({currentTask: nextTask})
        if (nextTask) {
          sessionStorage.setItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId), nextTask.taskId)
          nextTask._element.scrollIntoView({block: 'nearest', behavior: 'smooth'})
        }
        else {
          sessionStorage.removeItem(CacheKeys.TaskIdCurrent(this.props.match.params.projectId))
        }
        break
      case 80: // 'p'
        if (event.altKey) {
          printTaskTree(this.state.taskList)
        }
        break;
      case 81: // 'q'
        if (event.altKey) {
          let a = [1,2,3,4]
          console.log(a);
          console.log(a.splice(0, 3));
        }
        break;
      default:
    }
  }

  onStatusFilterChange = (value) => {
    this.setState({statusFilter: value})
    this.applyFilters(this.state.taskList,
      value, this.state.priorityFilter, this.state.dueDateDaysFilter,
      this.state.searchFilter, this.state.assigneeFilter)
  }

  onPriorityFilterChange = (value) => {
    this.setState({priorityFilter: value})
    this.applyFilters(this.state.taskList,
      this.state.statusFilter, value, this.state.dueDateDaysFilter,
      this.state.searchFilter, this.state.assigneeFilter)
  }

  onDueDateDaysFilterChange = (value) => {
    this.setState({dueDateDaysFilter: value})
    this.applyFilters(this.state.taskList,
      this.state.statusFilter, this.state.priorityFilter, value,
      this.state.searchFilter, this.state.assigneeFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.taskList,
      this.state.statusFilter, this.state.priorityFilter, this.state.dueDateDaysFilter,
      searchFilter, this.state.assigneeFilter)
  }

  onAssigneeFilterClick = (event) => {
    let assigneeFilter = event.target.getAttribute('data-user-id')
    if (assigneeFilter === this.state.assigneeFilter)
      assigneeFilter = '-1'
    this.setState({assigneeFilter: assigneeFilter})
    this.applyFilters(this.state.taskList,
      this.state.statusFilter, this.state.priorityFilter, this.state.dueDateDaysFilter,
      this.state.searchFilter, assigneeFilter)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.props.match.params.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({projectList: response.projectList, project : projectsFiltered[0]})
    }
    else {
      let context = this.props.context
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      this.props.history.replace('/projects')
    }
  }

  getProjectUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.props.match.params.projectId}/users`,
      cacheKey: CacheKeys.ProjectUsers(this.props.match.params.projectId),
      callback: this.getProjectUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getProjectUsersCallback = (response) => {
    let projectUserMap = response.projectUserList.reduce((map, user) => {map[user.userId] = user; return map}, {})
    this.setState({
      projectUserList: response.projectUserList,
      projectUserMap: projectUserMap
    })
  }

  getMessages(context) {
    let arr = [
      'c_refresh',
      'c_add_task',
      'c_no_task_msg',
      'c_unfold_tasks',
      'c_fold_tasks',
      'c_add_task',
      'c_delete_task',
      'c_make_subtask',
      'c_make_parent_task',
      'c_move_tasks',
      'c_project_users',
      'c_new_task',
      'c_delete',
      'c_cancel',
      'c_save',
      'c_delete_task_confirm',
      'c_none',
      // filters
      'c_status',
      'c_priority',
      'c_due_in_days',
      'c_all',
      //shortcuts
      'c_kb_shortcut_save',
      'c_kb_shortcut_cancel',
      'c_kb_shortcut_create',
      'c_kb_shortcut_delete',
      'c_kb_shortcut_indent',
      'c_kb_shortcut_outdent',
      //
      'c_project',
      'c_template'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_tasks', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }

  getTaskStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/taskStatuses`,
      cacheKey: CacheKeys.TaskStatuses(),
      callback: this.getTaskStatusesCallback,
      ttlInSecs: 3600*24*7
    })
    cacheManager.getObject2(context)
  }

  getTaskStatusesCallback = (response) => {
    this.setState({statusList: response.list.map(item => ({value: item.key, label: item.value}))})
  }

  getTaskPriorities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/taskPriorities2`,
      cacheKey: CacheKeys.TaskPriorities2(),
      callback: this.getTaskPrioritiesCallback,
      ttlInSecs: 3600*24*7
    })
    cacheManager.getObject2(context)
  }

  getTaskPrioritiesCallback = (response) => {
    this.setState({priorityList: response.list.map(item => ({value: item.key, label: item.value}))})
  }
}

export default withRouter(TaskListPageSF)
